var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m0,0l661,0l0,661l-661,0l0,-661z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    className: "SlideGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    clipPath: "url(#a)",
    className: "Slide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    className: "Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    className: "Graphic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m0,0l661,0l0,661l-661,0l0,-661z",
    fill: "none",
    className: "BoundingBox"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    id: "svg_7",
    d: "m568,92l-555,185l202,113l221,-166l-166,221l113,202l185,-555z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSendIcon);
export default __webpack_public_path__ + "static/media/linkedin-send-icon.7262131aab06e11234910ab90857f79b.svg";
export { ForwardRef as ReactComponent };